import { TranslationDictionary } from './translations';

// Component translations for client and barber components
export const componentTranslations: TranslationDictionary = {
  // Client Components - BookingFlow
  'booking.steps.selectBarber': {
    en: 'Select Barber',
    ro: 'Frizer',
  },
  'booking.steps.selectService': {
    en: 'Select Service',
    ro: 'Serviciu',
  },
  'booking.steps.chooseDateAndTime': {
    en: 'Choose Date & Time',
    ro: 'Data',
  },
  'booking.steps.confirm': {
    en: 'Confirm',
    ro: 'Confirmă',
  },
  'booking.steps.guestInfo': {
    en: 'Your Information',
    ro: 'Informații',
  },
  'booking.error.selectBarber': {
    en: 'Please select a barber',
    ro: 'Te rugăm să alegi un frizer',
  },
  'booking.error.selectService': {
    en: 'Please select a service',
    ro: 'Te rugăm să alegi un serviciu',
  },
  'booking.error.selectDateTime': {
    en: 'Please select appointment date and time',
    ro: 'Te rugăm să alegi data și ora programării',
  },
  'booking.error.fillGuestInfo': {
    en: 'Please fill in all guest information',
    ro: 'Te rugăm să completezi toate informațiile pentru vizitator',
  },
  'booking.error.validEmail': {
    en: 'Please enter a valid email address',
    ro: 'Te rugăm să introduci o adresă de email validă',
  },
  'booking.error.validPhone': {
    en: 'Please enter a valid phone number',
    ro: 'Te rugăm să introduci un număr de telefon valid',
  },
  'booking.error.createAppointment': {
    en: 'Failed to create appointment. Please try again.',
    ro: 'Nu s-a putut crea programarea. Te rugăm să încerci din nou.',
  },
  'booking.success.appointment': {
    en: 'Appointment booked successfully!',
    ro: 'Programare realizată cu succes!',
  },
  'booking.tabs.booking': {
    en: 'Booking',
    ro: 'Programare',
  },
  'booking.tabs.shop': {
    en: 'Shop',
    ro: 'Magazin',
  },
  'booking.enhancedExperience': {
    en: 'Try our enhanced booking experience',
    ro: 'Încearcă experiența noastră îmbunătățită de programare',
  },

  // Client Components - BarberSelection
  'barberSelection.title': {
    en: 'Choose a Barber',
    ro: 'Alege un stilist',
  },
  'barberSelection.loading': {
    en: 'Loading barbers...',
    ro: 'Se încarcă frizerii...',
  },
  'barberSelection.error': {
    en: 'Error loading barbers',
    ro: 'Eroare la încărcarea frizerilor',
  },
  'barberSelection.noBarbers': {
    en: 'No barbers available',
    ro: 'Nu există frizeri disponibili',
  },

  // Client Components - ServiceSelection
  'serviceSelection.title': {
    en: 'Select a Service',
    ro: 'Selectează un Serviciu',
  },
  'serviceSelection.loading': {
    en: 'Loading services...',
    ro: 'Se încarcă serviciile...',
  },
  'serviceSelection.error': {
    en: 'Error loading services',
    ro: 'Eroare la încărcarea serviciilor',
  },
  'serviceSelection.noServices': {
    en: 'No services available',
    ro: 'Nu există servicii disponibile',
  },
  'serviceSelection.duration': {
    en: 'Duration',
    ro: 'Durată',
  },
  'serviceSelection.price': {
    en: 'Price',
    ro: 'Preț',
  },

  // Client Components - DateTimeSelection
  'dateTimeSelection.title': {
    en: 'Choose Date & Time',
    ro: 'Alege Data și Ora',
  },
  'dateTimeSelection.loading': {
    en: 'Loading available slots...',
    ro: 'Se încarcă intervalele disponibile...',
  },
  'dateTimeSelection.noSlots': {
    en: 'No available time slots',
    ro: 'Nu există intervale de timp disponibile',
  },
  'dateTimeSelection.morning': {
    en: 'Morning',
    ro: 'Dimineață',
  },
  'dateTimeSelection.afternoon': {
    en: 'Afternoon',
    ro: 'După-amiază',
  },
  'dateTimeSelection.evening': {
    en: 'Evening',
    ro: 'Seară',
  },

  // Client Components - GuestInfoForm
  'guestInfo.title': {
    en: 'Your Information',
    ro: 'Informațiile Tale',
  },
  'guestInfo.name': {
    en: 'Full Name',
    ro: 'Nume Complet',
  },
  'guestInfo.email': {
    en: 'Email Address',
    ro: 'Adresă de Email',
  },
  'guestInfo.phone': {
    en: 'Phone Number',
    ro: 'Număr de Telefon',
  },
  'guestInfo.createAccount': {
    en: 'Create an account to manage your appointments',
    ro: 'Creează un cont pentru a-ți gestiona programările',
  },
  'guestInfo.submit': {
    en: 'Book Appointment',
    ro: 'Programează',
  },

  // Client Components - ConfirmationStep
  'confirmation.title': {
    en: 'Confirm Your Appointment',
    ro: 'Confirmă Programarea Ta',
  },
  'confirmation.barber': {
    en: 'Barber',
    ro: 'Frizer',
  },
  'confirmation.service': {
    en: 'Service',
    ro: 'Serviciu',
  },
  'confirmation.date': {
    en: 'Date',
    ro: 'Data',
  },
  'confirmation.time': {
    en: 'Time',
    ro: 'Ora',
  },
  'confirmation.price': {
    en: 'Price',
    ro: 'Preț',
  },
  'confirmation.confirm': {
    en: 'Confirm Booking',
    ro: 'Confirmă Programarea',
  },
  'confirmation.back': {
    en: 'Back',
    ro: 'Înapoi',
  },

  // Client Components - SuccessStep
  'success.title': {
    en: 'Booking Confirmed!',
    ro: 'Programare Confirmată!',
  },
  'success.message': {
    en: 'Your appointment has been successfully booked.',
    ro: 'Programarea ta a fost rezervată cu succes.',
  },
  'success.details': {
    en: 'Appointment Details',
    ro: 'Detalii Programare',
  },
  'success.bookAnother': {
    en: 'Book Another Appointment',
    ro: 'Programează o Altă Întâlnire',
  },
  'success.viewAppointments': {
    en: 'View My Appointments',
    ro: 'Vezi Programările Mele',
  },

  // Client Components - AppointmentHistory
  'appointmentHistory.title': {
    en: 'My Appointments',
    ro: 'Programările Mele',
  },
  'appointmentHistory.upcoming': {
    en: 'Upcoming',
    ro: 'Viitoare',
  },
  'appointmentHistory.past': {
    en: 'Past',
    ro: 'Trecute',
  },
  'appointmentHistory.loading': {
    en: 'Loading appointments...',
    ro: 'Se încarcă programările...',
  },
  'appointmentHistory.noAppointments': {
    en: 'No appointments found',
    ro: 'Nu s-au găsit programări',
  },
  'appointmentHistory.cancel': {
    en: 'Cancel',
    ro: 'Anulează',
  },
  'appointmentHistory.reschedule': {
    en: 'Reschedule',
    ro: 'Reprogramează',
  },

  // Client Components - Shop
  'shop.title': {
    en: 'Barber Shop',
    ro: 'Magazin Frizerie',
  },
  'shop.products': {
    en: 'Products',
    ro: 'Produse',
  },
  'shop.addToCart': {
    en: 'Add to Cart',
    ro: 'Adaugă în Coș',
  },
  'shop.viewCart': {
    en: 'View Cart',
    ro: 'Vezi Coșul',
  },
  'shop.checkout': {
    en: 'Checkout',
    ro: 'Finalizare Comandă',
  },
  'shop.emptyCart': {
    en: 'Your cart is empty',
    ro: 'Coșul tău este gol',
  },
  'shop.continueShopping': {
    en: 'Continue Shopping',
    ro: 'Continuă Cumpărăturile',
  },
  'shop.total': {
    en: 'Total',
    ro: 'Total',
  },

  // Barber Components - BarberDashboard
  'barberDashboard.title': {
    en: 'Barber Dashboard',
    ro: 'Panou de Control Frizer',
  },
  'barberDashboard.appointments': {
    en: 'Appointments',
    ro: 'Programări',
  },
  'barberDashboard.services': {
    en: 'Services',
    ro: 'Servicii',
  },
  'barberDashboard.schedule': {
    en: 'Schedule',
    ro: 'Program',
  },
  'barberDashboard.store': {
    en: 'Store',
    ro: 'Magazin',
  },
  'barberDashboard.loading': {
    en: 'Loading appointments...',
    ro: 'Se încarcă programările...',
  },

  // Barber Components - AppointmentCalendar
  'appointmentCalendar.today': {
    en: 'Today',
    ro: 'Astăzi',
  },
  'appointmentCalendar.month': {
    en: 'Month',
    ro: 'Lună',
  },
  'appointmentCalendar.week': {
    en: 'Week',
    ro: 'Săptămână',
  },
  'appointmentCalendar.day': {
    en: 'Day',
    ro: 'Zi',
  },
  'appointmentCalendar.noAppointments': {
    en: 'No appointments for this day',
    ro: 'Nu există programări pentru această zi',
  },
  'appointmentCalendar.client': {
    en: 'Client',
    ro: 'Client',
  },
  'appointmentCalendar.service': {
    en: 'Service',
    ro: 'Serviciu',
  },
  'appointmentCalendar.time': {
    en: 'Time',
    ro: 'Ora',
  },
  'appointmentCalendar.status': {
    en: 'Status',
    ro: 'Stare',
  },
  'appointmentCalendar.actions': {
    en: 'Actions',
    ro: 'Acțiuni',
  },
  'appointmentCalendar.markCompleted': {
    en: 'Mark as Completed',
    ro: 'Marchează ca Finalizat',
  },
  'appointmentCalendar.cancelAppointment': {
    en: 'Cancel Appointment',
    ro: 'Anulează Programarea',
  },
  'appointmentCalendar.rescheduleAppointment': {
    en: 'Reschedule Appointment',
    ro: 'Reprogramează',
  },
  'appointmentCalendar.confirmCancel': {
    en: 'Are you sure you want to cancel this appointment?',
    ro: 'Ești sigur că vrei să anulezi această programare?',
  },
  'appointmentCalendar.confirmComplete': {
    en: 'Are you sure you want to mark this appointment as completed?',
    ro: 'Ești sigur că vrei să marchezi această programare ca finalizată?',
  },
  'appointmentCalendar.rescheduleTitle': {
    en: 'Reschedule Appointment',
    ro: 'Reprogramează Întâlnirea',
  },
  'appointmentCalendar.newDate': {
    en: 'New Date',
    ro: 'Dată Nouă',
  },
  'appointmentCalendar.newTime': {
    en: 'New Time',
    ro: 'Oră Nouă',
  },
  'appointmentCalendar.save': {
    en: 'Save Changes',
    ro: 'Salvează Modificările',
  },
  'appointmentCalendar.cancel': {
    en: 'Cancel',
    ro: 'Anulează',
  },
  'appointmentCalendar.yes': {
    en: 'Yes',
    ro: 'Da',
  },
  'appointmentCalendar.no': {
    en: 'No',
    ro: 'Nu',
  },

  // Barber Components - AppointmentList
  'appointmentList.upcoming': {
    en: 'Upcoming Appointments',
    ro: 'Programări Viitoare',
  },
  'appointmentList.past': {
    en: 'Past Appointments',
    ro: 'Programări Trecute',
  },
  'appointmentList.noAppointments': {
    en: 'No appointments found',
    ro: 'Nu s-au găsit programări',
  },
  'appointmentList.date': {
    en: 'Date',
    ro: 'Data',
  },
  'appointmentList.time': {
    en: 'Time',
    ro: 'Ora',
  },
  'appointmentList.client': {
    en: 'Client',
    ro: 'Client',
  },
  'appointmentList.service': {
    en: 'Service',
    ro: 'Serviciu',
  },
  'appointmentList.status': {
    en: 'Status',
    ro: 'Stare',
  },
  'appointmentList.actions': {
    en: 'Actions',
    ro: 'Acțiuni',
  },

  // Barber Components - ServiceManagement
  'serviceManagement.title': {
    en: 'Service Management',
    ro: 'Gestionare Servicii',
  },
  'serviceManagement.addService': {
    en: 'Add New Service',
    ro: 'Adaugă Serviciu Nou',
  },
  'serviceManagement.editService': {
    en: 'Edit Service',
    ro: 'Editează Serviciu',
  },
  'serviceManagement.name': {
    en: 'Service Name',
    ro: 'Nume Serviciu',
  },
  'serviceManagement.description': {
    en: 'Description',
    ro: 'Descriere',
  },
  'serviceManagement.duration': {
    en: 'Duration (minutes)',
    ro: 'Durată (minute)',
  },
  'serviceManagement.price': {
    en: 'Price',
    ro: 'Preț',
  },
  'serviceManagement.save': {
    en: 'Save Service',
    ro: 'Salvează Serviciu',
  },
  'serviceManagement.cancel': {
    en: 'Cancel',
    ro: 'Anulează',
  },
  'serviceManagement.delete': {
    en: 'Delete',
    ro: 'Șterge',
  },
  'serviceManagement.confirmDelete': {
    en: 'Are you sure you want to delete this service?',
    ro: 'Ești sigur că vrei să ștergi acest serviciu?',
  },

  // Barber Components - WorkingHours
  'workingHours.title': {
    en: 'Working Hours',
    ro: 'Program de Lucru',
  },
  'workingHours.monday': {
    en: 'Monday',
    ro: 'Luni',
  },
  'workingHours.tuesday': {
    en: 'Tuesday',
    ro: 'Marți',
  },
  'workingHours.wednesday': {
    en: 'Wednesday',
    ro: 'Miercuri',
  },
  'workingHours.thursday': {
    en: 'Thursday',
    ro: 'Joi',
  },
  'workingHours.friday': {
    en: 'Friday',
    ro: 'Vineri',
  },
  'workingHours.saturday': {
    en: 'Saturday',
    ro: 'Sâmbătă',
  },
  'workingHours.sunday': {
    en: 'Sunday',
    ro: 'Duminică',
  },
  'workingHours.closed': {
    en: 'Closed',
    ro: 'Închis',
  },
  'workingHours.startTime': {
    en: 'Start Time',
    ro: 'Ora de Început',
  },
  'workingHours.endTime': {
    en: 'End Time',
    ro: 'Ora de Sfârșit',
  },
  'workingHours.save': {
    en: 'Save Working Hours',
    ro: 'Salvează Programul',
  },

  // Barber Components - VacationDays
  'vacationDays.title': {
    en: 'Vacation Days',
    ro: 'Zile de Vacanță',
  },
  'vacationDays.addVacation': {
    en: 'Add Vacation Period',
    ro: 'Adaugă Perioadă de Vacanță',
  },
  'vacationDays.startDate': {
    en: 'Start Date',
    ro: 'Data de Început',
  },
  'vacationDays.endDate': {
    en: 'End Date',
    ro: 'Data de Sfârșit',
  },
  'vacationDays.reason': {
    en: 'Reason (optional)',
    ro: 'Motiv (opțional)',
  },
  'vacationDays.save': {
    en: 'Save',
    ro: 'Salvează',
  },
  'vacationDays.cancel': {
    en: 'Cancel',
    ro: 'Anulează',
  },
  'vacationDays.delete': {
    en: 'Delete',
    ro: 'Șterge',
  },
  'vacationDays.noVacations': {
    en: 'No vacation days scheduled',
    ro: 'Nu sunt programate zile de vacanță',
  },

  // Barber Components - StoreManagement
  'storeManagement.title': {
    en: 'Store Management',
    ro: 'Gestionare Magazin',
  },
  'storeManagement.products': {
    en: 'Products',
    ro: 'Produse',
  },
  'storeManagement.orders': {
    en: 'Orders',
    ro: 'Comenzi',
  },
  'storeManagement.addProduct': {
    en: 'Add New Product',
    ro: 'Adaugă Produs Nou',
  },
  'storeManagement.editProduct': {
    en: 'Edit Product',
    ro: 'Editează Produs',
  },
  'storeManagement.productName': {
    en: 'Product Name',
    ro: 'Nume Produs',
  },
  'storeManagement.description': {
    en: 'Description',
    ro: 'Descriere',
  },
  'storeManagement.price': {
    en: 'Price',
    ro: 'Preț',
  },
  'storeManagement.stock': {
    en: 'Stock Quantity',
    ro: 'Cantitate în Stoc',
  },
  'storeManagement.image': {
    en: 'Product Image',
    ro: 'Imagine Produs',
  },
  'storeManagement.save': {
    en: 'Save Product',
    ro: 'Salvează Produs',
  },
  'storeManagement.cancel': {
    en: 'Cancel',
    ro: 'Anulează',
  },
  'storeManagement.delete': {
    en: 'Delete',
    ro: 'Șterge',
  },
  'storeManagement.confirmDelete': {
    en: 'Are you sure you want to delete this product?',
    ro: 'Ești sigur că vrei să ștergi acest produs?',
  },

  // Status translations
  'status.pending': {
    en: 'Pending',
    ro: 'În așteptare',
  },
  'status.confirmed': {
    en: 'Confirmed',
    ro: 'Confirmat',
  },
  'status.completed': {
    en: 'Completed',
    ro: 'Finalizat',
  },
  'status.cancelled': {
    en: 'Cancelled',
    ro: 'Anulat',
  },
  'status.noShow': {
    en: 'No Show',
    ro: 'Neprezentare',
  },
}; 